import {Request} from '@flexiblelibrary/js-requests';

import {
	simpleRequest,
	securedRequest,
	securedPutRequest
} from '@Services/RequestService';

import { defaultListMaping } from './maping/DefaultMaping';

Request.registrationDrivers({
	'simple': simpleRequest,
	'secured': securedRequest,
	'secured_put': securedPutRequest,
});

export default class RequestApi {
	static init = () => {
		Request.group({prefix: 'backoffice'}, () => {
			Request.group({prefix: 'v1'}, () => {
				Request.group({driver: 'simple'}, () => {
					Request.group({prefix: 'auth'}, () => {
						Request.post('login', 'UserAuthRequest@login');
					})
				});

				Request.group({driver: 'secured'}, () => {
					Request.get('permissions', 'UserAuthRequest@getPermissions');

					Request.get('users', 'UserRequest@usersList', defaultListMaping);
					Request.get('users/{id}', 'UserRequest@userDetail');
					Request.post('users', 'UserRequest@createUser');
					Request.put('users', 'UserRequest@editUser');
					Request.get('roles', 'UserRequest@getRoles');

					Request.get('order', 'TransactionsRequest@getTransactionsList', defaultListMaping);
					Request.get('order/{id}', 'TransactionsRequest@getOrderById');
					Request.put('order/{id}', 'TransactionsRequest@editOrderById');
					Request.get('order/export', 'TransactionsRequest@export');


					Request.get('deals/active', 'ActiveDealsRequest@getDealsList', defaultListMaping);
					Request.get('deals/active-export', 'ActiveDealsRequest@export');
					Request.get('symbol', 'ActiveDealsRequest@getSymbolList')

					Request.get('deals/closed', 'ClosedDealsRequest@getDealsList', defaultListMaping);
					Request.get('deals/closed-export', 'ClosedDealsRequest@export');
					Request.get('symbol', 'ClosedDealsRequest@getSymbolList');
					
					Request.get('transaction-order', 'TransactionCurrencyRequest@getTransactionCurrencyList', defaultListMaping);
					Request.get('transaction-order/export', 'TransactionCurrencyRequest@export');
					
					Request.get('trading-account', 'AccountsRequest@getAccountsList', defaultListMaping);
					Request.get('trading-account/export', 'AccountsRequest@export');
					
					Request.get('client', 'ClientsRequest@getClientsList', defaultListMaping);
					Request.get('client/export', 'ClientsRequest@export');

					Request.get('client/{id}', 'ClientRequest@getClientInfoById');
					Request.post('client/activate', 'ClientRequest@activateClient');
					Request.post('client/archive', 'ClientRequest@archiveClient');
					Request.post('comment', 'ClientRequest@addComment');
					Request.get('comment/{id}', 'ClientRequest@getCommentByClientId', defaultListMaping);
					Request.get('deals/active-by-client/{id}', 'ClientRequest@getActiveDealsByClient', defaultListMaping);
					Request.get('deals/closed-by-client/{id}', 'ClientRequest@getClosedDealsByClient', defaultListMaping);
					Request.get('transaction-order/client/{id}', 'ClientRequest@getTransactionsByClient', defaultListMaping);
					Request.get('trading-account/{id}', 'ClientRequest@getAccountsByClient');
					
					Request.get('trading-account-groups', 'ActiveDealsRequest@getTradingAccountGroups');
				});
			});
		});
	}
}
